
const useDownloadFiles = () => {

    async function downloadFile(pathFile: string, format: string, nameFile: string) {
        try {
            fetch(pathFile).then((response) => {
                response.blob().then((blob) => {
                    const fileURL = window.URL.createObjectURL(blob);
                    let alink = document.createElement("a");
                    alink.href = fileURL;
                    alink.download = `${nameFile}.${format}`;
                    alink.click();
                });
            });
        } catch (error: any) {
            throw new Error('error download ', error)
        }
    }

    return {
        downloadFile
    }
}

export default useDownloadFiles